import React, { ReactElement } from 'react';
import {
  Redirect, Route, Switch,
} from 'react-router-dom';
import './App.css';
import styled from 'styled-components';
import ClipLoader from 'react-spinners/ClipLoader';
import Debug from './views/Debug';
import { useGetDeviceInfo } from './hooks/useGetDeviceInfo';
import { useOrientation } from './hooks/useOrientation';
import AdLoop from './views/AdLoop/AdLoop';
import AwaitingApproval from './views/AwaitingApproval';
import AppWithUuid from './components/AppWithUuid';

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100vh;
  padding: 20% 5% 5%;
`;

const AppContent: React.FC = (): ReactElement => {
  const { isLoading, device, isPending } = useGetDeviceInfo();
  const { orientation, mongoRotate } = useOrientation({ device });

  if (isLoading) {
    return (
      <LoadingContainer>
        <ClipLoader color='rgb(31, 182, 255)' size={50} />
      </LoadingContainer>
    );
  }

  if (isPending) {
    return <AwaitingApproval />;
  }

  if (!device) {
    return (
      <LoadingContainer>
        <ClipLoader color='rgb(31, 182, 255)' size={50} />
      </LoadingContainer>
    );
  }

  return (
    <div className={`app ${orientation} deg-${mongoRotate}`}>
      <Switch>
        <Route exact path='/home'>
          <AdLoop device={device} />
        </Route>
        <Route exact path='/debug'>
          <Debug />
        </Route>
        <Redirect to='/home' />
      </Switch>
    </div>
  );
};

const App: React.FC = (): ReactElement => (
  <AppWithUuid>
    <AppContent />
  </AppWithUuid>
);

export default App;
